<template lang="html">
  <div class="modal-wrapper">
      <div class="modal-close">
        <img @click="closeModal()" src="@/assets/icons/close.png" alt="close-modal-img">
      </div>
       <LoginDropdown @changeLoged="changeLoged($event)" :modalDrop="true"/>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
import LoginDropdown from '@/components/header/LoginDropdown.vue'
export default {
  name: 'signInMod',
  components: {
    LoginDropdown
  },
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {
    closeModal () {
      eventBus.$emit('closeModal')
    },
    changeLoged (e) {
      eventBus.$emit('changeLoged', e)
      this.closeModal()
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 295px;
  max-width: 80%;
  height: 410px;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";
  padding: 15px !important;

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
}

/*
.center{
    position: relative;
    box-sizing: border-box;
    width:100%;
    height: 90%;
    display: flex;
    justify-content:center;
    align-items: center;
    text-align: center;
  }*/
</style>
